import Mastercard from './Mastercard';

export default Mastercard;
